/**
 * @deprecated Use services/dayjs from services workspace.
 */
export const DEFAULT_DATE_FORMAT = "MM/DD/YYYY";

export const DEFAULT_DATE_TIME_FORMAT = "MM/DD/YYYY hh:mm:ss";

export const EST_ZONE = "America/New_york";

export const DEFAULT_DATE_TIME_FORMAT_WITH_ZONE = `${DEFAULT_DATE_TIME_FORMAT} z`;

export const DATE_FORMAT_FOR_PICKING_DATE = "MMM DD, YYYY";

export const DATE_FORMAT_FOR_MOMENTS_TAB = "MMM D";
